import WELFARE from './welfare/pt-BR';
import PET from './pet/pt-BR';

const realizaModule = {
  WELFARE,
  PET,
};

export default realizaModule;
